import React from 'react';
import type { IUrlLinkItem } from '../../../../ui';
import { FooterLink } from '../../../../ui/new-components/FooterLink';
import { withTranslate } from '../../i18n/translate';
import { cn } from '../../utils/cn';

const FULL_YEAR = new Date().getFullYear();

export interface IFooterFinePrintProps {
	links: IUrlLinkItem[];
}

export const FooterFinePrint = withTranslate<IFooterFinePrintProps>(
	({ links, t }) => (
		<div
			className={cn(
				'flex justify-between items-end',
				'tablet:mt-10',
				'max-mobile:flex-col max-mobile:justify-start max-mobile:items-center',
			)}
		>
			<div
				className={cn(
					'text-base mr-5',
					'max-mobile:w-full max-mobile:mr-0',
					'[&>strong]:max-mobile:block',
				)}
			>
				<strong>{t('web_footer_copyright_text', { year: FULL_YEAR })}</strong>
				{links.map((link) => (
					<FooterLink
						key={link.key}
						href={link.url}
						className={cn(
							'ml-5',
							'max-mobile:block max-mobile:mt-5 max-mobile:ml-0',
						)}
					>
						{link.title}
					</FooterLink>
				))}
			</div>
		</div>
	),
);
